export const GET_ORGANISMES_PAC: '@PAC/GET_ORGANISMES_PAC' =
  '@PAC/GET_ORGANISMES_PAC';

export const SET_ORGANISMES_PAC: '@PAC/SET_ORGANISMES_PAC' =
  '@PAC/SET_ORGANISMES_PAC';

export const SET_PAC_OBJECT: '@PAC/SET_PAC_OBJECT' = '@PAC/SET_PAC_OBJECT';

export const GET_PAC_CATEGRY_PARAM: '@PAC/GET_PAC_CATEGRY_PARAM' =
  '@PAC/GET_PAC_CATEGRY_PARAM';

export const SET_PAC_CATEGRY_PARAM: '@PAC/SET_PAC_CATEGRY_PARAM' =
  '@PAC/SET_PAC_CATEGRY_PARAM';

export const SEND_PAC_INFOS: '@PAC/SEND_PAC_INFOS' = '@PAC/SEND_PAC_INFOS';

export const SET_PAC_RESPONSE: '@PAC/SET_PAC_RESPONSE' =
  '@PAC/SET_PAC_RESPONSE';
